import { adminHttpClient } from "../../../commons/adminHttpClinet";
import models from "../../../models";
import { GetListOfDevices, PaginatedDeciceIdsUsersModel } from "../../../models/dashboard/users/user";

const getDeviceWithMoreUsers = ( searchParams: GetListOfDevices ): Promise<PaginatedDeciceIdsUsersModel> => {

    return adminHttpClient.get(`/api/Admin/AdminUsers/device-multiple-users?PageNumber=${searchParams.pageNumber}&PageSize=${searchParams.pageSize}&OrderDescending=${searchParams.orderDescending}&SearchFor=${searchParams.searchFor}`)
}

export default getDeviceWithMoreUsers;